import { Machine } from "stent";
import {
  retrieveDataFromAsyncStorage,
  removeDataFromAsyncStorage
} from "screens/common/utils";
import { navigate } from "utils/routing/NavRouter";
import { pushClevertapEvent } from "utils/clevertapEvents";
import { screenNames } from "./utils/constants";
import { isRegistrationIncomplete, navigateToLoggedIn } from "./utils";

const onBackClevertap = (pageModal, state) => {
  pushClevertapEvent("loginRegister Clicks", {
    Type: `Back`,
    Current_Page: "New loginRegistration",
    Test_Case: state.variant,
    Page_Modal: pageModal
  });
};

const getNextScreen = ({ user, state = {}, authSignIn }) => {
  let newState = { ...state, onLocationBack: false, user };
  const missingRegistrationStep = isRegistrationIncomplete(
    user,
    newState.variant
  );

  if (missingRegistrationStep) {
    newState = { ...newState, name: missingRegistrationStep };
  } else if (state.isNewUser) {
    // newState = { ...newState, name: screenNames.SuccessComponent };
    navigateToLoggedIn({ query: state.query, user, authSignIn });
  } else {
    navigateToLoggedIn({ query: state.query, user, authSignIn });
  }

  return newState;
};

const stateTransitions = {
  [screenNames.LoginSignUpComponent]: {
    goNext: (state, { goTo, user, isNewUser }) => {
      let newState = { ...state, user, isNewUser };

      if (goTo === "NextScreen") {
        newState = getNextScreen({ state: { ...state, isNewUser }, user });
      } else {
        newState = {
          ...newState,
          name: screenNames.OTPComponent,
          goBackScreen: screenNames.LoginSignUpComponent
        };
      }
      return newState;
    }
  },
  [screenNames.OTPComponent]: {
    goNext: (state, { user, authSignIn }) => {
      return getNextScreen({ state, user, authSignIn });
    },
    goBack: (state) => {
      onBackClevertap("OTP Verification", state);
      const newState = {
        ...state,
        name: state.goBackScreen || screenNames.LoginSignUpComponent
      };
      return newState;
    }
  },
  [screenNames.BasicDetailComponent]: {
    goNext: (state, { user }) => {
      return getNextScreen({ state, user });
    }
  },
  [screenNames.ProfessionalDetailComponent]: {
    goNext: (state, { user }) => {
      return getNextScreen({ state, user });
    },
    goBack: (state) => {
      onBackClevertap("Personal details - Page 2", state);
      const newState = {
        ...state,
        name: screenNames.BasicDetailComponent
      };
      return newState;
    }
  },
  [screenNames.FAComponent]: {
    goNext: (state, { user, authSignIn }) => {
      return getNextScreen({ state, user, authSignIn });
    },
    goBack: (state) => {
      onBackClevertap("FA Select", state);
      const newState = {
        ...state,
        name:
          state.variant === "A"
            ? screenNames.ProfessionalDetailComponent
            : screenNames.BasicDetailComponent
      };
      return newState;
    }
  }

  // [screenNames.WorkExperienceComponent]: {
  //   goNext: (state, { user }) => {
  //     return getNextScreen({ state, user });
  //   },
  //   goBack: state => {
  //     onBackClevertap("Work Experience");
  //     const newState = {
  //       ...state,
  //       name: screenNames.FAComponent
  //     };
  //     return newState;
  //   }
  // },

  // [screenNames.LocationComponent]: {
  //   goNext: (state, { user }) => {
  //     return getNextScreen({ state, user });
  //   },
  //   goBack: state => {
  //     onBackClevertap("Location Select");
  //     const newState = {
  //       ...state,
  //       onLocationBack: true,
  //       name: screenNames.WorkExperienceComponent
  //     };
  //     return newState;
  //   }
  // },

  // [screenNames.SuccessComponent]: {
  //   goNext: props => {}
  // }
};

const initializeStateMachine = ({ initialScreenName, initialState }) => {
  Machine.create("LoginRegistrationStateMachine", {
    state: {
      name: initialScreenName,
      user: {},
      screenState: {},
      ...initialState
    },
    transitions: stateTransitions
  });
};

export default initializeStateMachine;
